<script setup lang="ts">
defineProps({
  colorBackground: {
    type: String,
    default: "--color-accent-200",
  },

  rounded: {
    type: Boolean,
    default: false,
  },

  shadow: {
    type: Boolean,
    default: false,
  },

  outline: {
    type: Boolean,
    default: false,
  },

  explodeHeight: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <div
    :class="['widget-layout', $style.container, rounded && $style.rounded, shadow && $style.shadow, explodeHeight && $style.explodeHeight, outline && $style.outline]"
    :style="{ 'background-color': `var(${colorBackground})` }"
  >
    <slot name="widgetRows" />
  </div>
</template>

<style module>
.container {
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: auto;
  /* padding: 1rem 0.25rem; */
  background-color: magenta;
}

.rounded {
  border-radius: var(--border-radius-large);
}

.shadow {
  box-shadow: var(--box-shadow-small);
}

.outline {
  border: 1px solid var(--color-accent-200);
}

.explodeHeight {
  height: 100%;
}

:global(.widget-layout .widget-layout-row:not(:last-child)) {
  /* margin-bottom: 1.5rem; */
}
</style>
